import './App.css';
import "./index.css";
import WordleRomanian from './WorldeRomanian';
import words from './words.json';
import guessable from './guessable.json';

function App() {
  return (
    <div className="App">
      <WordleRomanian words={words} guessable={guessable}/>
    </div>
  );
}

export default App;
